import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { AccordionComponent } from './../accordion/accordion.component';
import { BaseComponent } from './../base/base.component';
import { Subject } from 'rxjs/Subject';
import { MainComponent } from '../main-component/main.component';

@Component({
  selector: 'app-select-list',
  styleUrls: ['./select-list.component.scss'],
  templateUrl: './select-list.component.html'
})
export class SelectListComponent extends BaseComponent {
  children: Array<any>;
  nodeObservable: Subject<boolean>;
  @Input() header:{ title: string; version: string };

  @Input() isEnable: boolean;

  @Input() lists: Array<AccordionComponent>;

  @Input() isEdit: boolean;
  
  selectedItems: Array<AccordionComponent>;

  @Output() isDuplicate = new EventEmitter<object>();

  @Output() clearSelection = new EventEmitter<any>();

  @ViewChild('treeAccordion') acc: AccordionComponent

  nodeIndex: number;

  constructor(ele: ElementRef) {
    super(ele);
    this.lists = new Array<AccordionComponent>();
    this.selectedItems = new Array<AccordionComponent>();
    this.nodeIndex = 0;
  }

  isSelected(index: number): boolean {
    return this.selectedItems.filter((result) => result.index === index).length > 0 ? true : false;
  }

  addList(event) {
    if (event.dataTransfer === undefined) {
      this.addNode(event);
    } else {
      const arr: Array<AccordionComponent> = JSON.parse(event.dataTransfer.getData('text'));
      this.addNode(arr);
    }
    this.acc.flag = false;
    this.acc.nodes = this.lists;
  }

  addNode(arr) {
    const duplicateData = new Array<AccordionComponent>();
    for (let i = 0; i < arr.length; i++) {
      const cloneNode: AccordionComponent = Object.assign({}, arr[i]);
      cloneNode.index = this.nodeIndex++;
      if (this.lists.filter(
        (result) => result.assignment + result.skill === arr[i].assignment + arr[i].skill).length === 0) {
        this.lists.push(cloneNode);
      } else {
        duplicateData.push(cloneNode);
      }
    }
    if (duplicateData.length !== 0) {
      this.isDuplicate.emit({ list: this.lists, data: duplicateData, event: 'isDuplicate' });
    }
    this.lists = this.sortNodes(this.lists);
    this.clearSelection.emit();
  }

  sortNodes(skills) {
    for(const skill of skills) {
      const index = this.findIndexOfSkillInClientTrainingList(skill.skillId);
      skill.priority = index !== -1 ? index : 10000;
    }
    skills.sort(function(a, b) {
      return a.priority - b.priority;
    });
    return skills;
  }

  findIndexOfSkillInClientTrainingList(name) {
    let list = MainComponent.getTrainingList();
    for (let i = 0; i < list.length; i++) {
      if (list[i].skillId === name) {
        return i;
      }
    }
    return -1;
  }

  removeList(arr: Array<AccordionComponent>) {
    const length = this.lists.length;
    for (let i = 0; i < length; i++) {
      let index = this.lists.indexOf(arr[i]);
      if (index > -1) {
        this.lists.splice(index, 1);
      }
      index = this.selectedItems.indexOf(arr[i]);
      if (index > -1) {
        this.selectedItems.splice(this.selectedItems.indexOf(arr[i]), 1);
      }
    }
  }

  move(direction: DIRECTION, arr: Array<AccordionComponent>) {
    const helpingArray = [];
    for (let i = 0; i < arr.length; i++) {
      helpingArray.push(this.lists.indexOf(arr[i]));
    }
    let index = -1;
    let minVal = 0;
    let maxVal = this.lists.length - 1;
    const length = arr.length;
    for (let i = 0; i < length; i++) {
      let arrIndex = -1;
      if (direction === DIRECTION.DOWN) {
        index = Math.max.apply(null, helpingArray);
        arrIndex = arr.indexOf(this.lists[index]);
        if (index !== maxVal) {
          this.lists.splice(index + 2, 0, arr[arrIndex]);
          this.lists.splice(index, 1);
        } else {
          maxVal--;
        }
      } else if (direction === DIRECTION.UP) {
        index = Math.min.apply(null, helpingArray);
        arrIndex = arr.indexOf(this.lists[index]);
        if (index !== minVal) {
          this.lists.splice(index - 1, 0, arr[arrIndex]);
          this.lists.splice(index + 1, 1);
        } else {
          minVal++;
        }
      }
      helpingArray.splice(arrIndex, 1);
      arr.splice(arrIndex, 1);
    }
  }

  dragOver(event) {
    event.preventDefault();
  }

  onClick(index: number, isCtrl: boolean) {
    if (!isCtrl) {
      this.selectedItems.length = 0;
    }

    if (this.selectedItems.filter((result) => result.index === index).length > 0 && this.selectedItems.length > 1) {
      this.selectedItems = this.selectedItems.filter((result) => result.index !== index);
    } else if (this.selectedItems.filter((result) => result.index === index).length === 0) {
      this.selectedItems.push(this.lists.filter((result) => result.index === index)[0]);
    }
  }

  clearTrainingList() {
    this.lists.length = 0;
  }

  getList(): Array<AccordionComponent> {
    return this.lists;
  }

  resetSelectionList() {
    this.lists = new Array<AccordionComponent>();
    this.selectedItems = new Array<AccordionComponent>();
    this.nodeIndex = 0;
  }


}

export enum DIRECTION {
  UP = 0,
  DOWN = 1
}



// WEBPACK FOOTER //
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/select-list/select-list.component.ts